import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Loader2 } from 'lucide-react';
import './Report-scope.css'

const DataTable = ({ data, isLoading, error }) => {
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');

  const columnsToDisplay = [
    { label: 'Scope Title', key: 'scope_title' },
    { label: 'Program Tags', key: 'project_tags' },
    { label: 'Scope Item URL', key: 'scope_items_url1' },
    { label: 'Out of Scope Item URL', key: 'out_Of_scope_item_url1' },
    { label: 'Expected Vulnerabilities', key: 'expected_vulnerability_types' },
    { label: 'Types of Testing Allowed', key: 'testing_allowed' },
    { label: 'Languages & Frameworks', key: 'language_framworks' },
    { label: 'Asset Environments', key: 'asset_environments' },
  ];

  const handleSort = (columnKey) => {
    if (sortColumn === columnKey) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(columnKey);
      setSortDirection('asc');
    }
  };

  const getSortedData = () => {
    if (!sortColumn) return data;
    return [...data].sort((a, b) => {
      const valA = a[sortColumn] || '';
      const valB = b[sortColumn] || '';
      if (typeof valA === 'string' && typeof valB === 'string') {
        return sortDirection === 'asc'
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }
      return sortDirection === 'asc' ? valA - valB : valB - valA;
    });
  };

  const renderSortIcon = (columnKey) => {
    if (sortColumn !== columnKey) return null;
    return sortDirection === 'asc' ? <ChevronUp size={16} /> : <ChevronDown size={16} />;
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '250px' }}>
        <Loader2 className="me-2 text-primary" style={{ animation: 'spin 1s linear infinite' }} />
        <span className="text-primary fw-medium">Loading data...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger">
        <strong>Error:</strong> {error.message || 'Something went wrong while fetching data.'}
      </div>
    );
  }

  const sortedData = getSortedData();

  return (
   <div className="report-table-container">
  <table className="report-table">
    <thead>
      <tr>
        <th>Scope</th>
        <th>Values</th>
      </tr>
    </thead>
    <tbody>
      {columnsToDisplay.map((col) => (
        <tr key={col.key}>
          <th>{col.label}</th>
          <td>
            {Array.isArray(data?.[0]?.[col.key]) ? (
              <ul className="ps-3 mb-0" style={{ listStyleType: 'disc', paddingLeft: '1rem' }}>
                {data[0][col.key].map((item, i) => (
                  <li key={i} style={{ marginBottom: '6px' }}>
                    {item.includes?.('http') ? (
                      <a
                        href={item}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item}
                      </a>
                    ) : (
                      item
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              data?.[0]?.[col.key] || '-'
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
  );
};

export default DataTable;
